import React from "react";

//
import PageHeader from "../../components/general/PageHeader";
import SectionTitle from "../../components/general/SectionTitle";
import BestInWeeks from "../../components/crypto-coins/BestInWeeks";

function CryptoCoins() {
  return (
    <div id="crypto-coins">
      <PageHeader
        title="Volume Change"
        subject="Overview and analytics"
      />

      <SectionTitle text="Most hourly volume changes" />

      <BestInWeeks/>
    </div>
  );
}

export default CryptoCoins;
